module.exports = __webpack_public_path__ + "static/redaway-e9bbcd5612292029b94959d48467ffb7.png";